class RequestPasswordResetService {
  constructor($http, config,httpDim) {
    this.$http = $http;
    this.config = config;
    this.httpDim = httpDim;
  }

  requestReset(email) {
    let config = this.config;
    let url = `${config.apiRoot}/passwordResetEmail?email=${email}`;

    url = this.httpDim.appendCacheBust(url);

    return this.$http.get(url, config);
  }
}

RequestPasswordResetService.$inject = ['$http', 'config','httpDim'];

export default RequestPasswordResetService;



// WEBPACK FOOTER //
// ./app/components/requestPasswordReset/requestPasswordReset.service.js